import { render, staticRenderFns } from "./PayrollPaymentPersons.vue?vue&type=template&id=05ca50e0&"
import script from "./PayrollPaymentPersons.vue?vue&type=script&lang=js&"
export * from "./PayrollPaymentPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports